export default function validateConfig(config = {}, requiredFields) {
  if (requiredFields) {
    requiredFields.forEach(field => {
      if (!(field in config))
        throw new Error(`Не указан обязательный параметр ${field}`);
    });
  }
}
